import React, { useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Spinner, Input} from "@nextui-org/react";
import { GET } from "../../../../utils/requests";
import { LEASING_TYPES, TYPES } from "../../../../utils/types";
import {Table, TableHeader, TableColumn, TableBody, TableRow, TableCell} from "@nextui-org/react";
import ReqOkayModal from "./reqOkay";
import PrintOkayModal from "./printOkay";
import { MdDeleteOutline } from "react-icons/md";
import { toast } from "react-toastify";
import { FaCheck } from "react-icons/fa";
import moment from "moment";
import { orders_uri } from "../../../../utils/url";


export default function ReqDetailModal({callback, data}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [load, setLoad] = useState(false);
  const [datas, setDatas] = useState([]);
  const [allpay, setAllpay] = useState();
  const [checkedTracks, setCheckedTracks] = useState([]);
  const [checkload, setCheckload] = useState(false);

  const handlecal = () => {
    callback();
  }

  const Get = async () => {
    setLoad(true);
    try{
        const res = await GET(orders_uri+`/userfind?status=${TYPES.IRSEN}&type=${TYPES.REQUESTED}&phone=${data.user.phone_no}&deposit=${data.user.deposit}`);
        setDatas(res.data);
        // setAllpay(res.data.reduce((a,v) =>  a = a + Number(v.pay) , 0 ).toLocaleString());
        setAllpay(
          res.data.reduce((total, item) => total + Number(item.pay * item.too), 0).toLocaleString()
        );
        setLoad(false);
    }catch(err){
        console.log(err);
        setLoad(false);
    }
  }

    // const calculateTotalPayment = () => {
    //   return checkedTracks.reduce((total, track) => total + parseFloat(track.pay), 0);
    // };
    const calculateTotalPayment = () => {
      return checkedTracks.reduce((total, track) => total + parseFloat(track.pay * track.too), 0);
    };
    
  
  const handleCheckClick = (item) => {
    const track = checkedTracks.filter(it => it.id === item.id);
    if(track.length > 0){
      setDatas((prevData) => prevData.filter((dataItem) => dataItem.id !== item.id));
      return toast.warning("Энэ бараа аль хэдийн сонгогдсон байна !");
    }
    setCheckedTracks((prevCheckedTracks) => [...prevCheckedTracks, item]);
    setDatas((prevData) => prevData.filter((dataItem) => dataItem.id !== item.id));
  };

  const handleDeleteClick = (item) => {
    const track = datas.filter(it => it.id === item.id);
    if(track.length > 0){
      setCheckedTracks((prevData) => prevData.filter((dataItem) => dataItem.id !== item.id));
    }else{
      setCheckedTracks((prevData) => prevData.filter((dataItem) => dataItem.id !== item.id));
      setDatas((prevCheckedTracks) => [...prevCheckedTracks, item]);
    }
  };

  const callOpen =()=>{
    onOpen();
    Get();
  }

  return (
    <>
      <Button size="sm" className="bg-gray-200 text-gray-600" onPress={callOpen}>Дэлгэрэнгүй</Button>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange} scrollBehavior='inside' size="5xl">
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex justify-between gap-1 font-Roboto">
                <h1>Хүргэлтийн дэлгэрэнгүй мэдээлэл ---  <span className="font-bold text-red-800 2xl">{data.user.phone_no}</span></h1>
                <div className="mr-4">
                  <PrintOkayModal data={data} allpay={allpay} too={checkedTracks.length}/>
                </div>
              </ModalHeader>
              <ModalBody>
                <div className="font-Roboto flex justify-between">
                    <div className="w-full">
                      <Table aria-label="Example static collection table">
                          <TableHeader>
                              <TableColumn>БАРААНЫ НЭР</TableColumn>
                              <TableColumn>БАРААНЫ ҮНЭ</TableColumn>
                              <TableColumn>УТАС/ДАНС</TableColumn>
                              <TableColumn>ТОО ШИРХЭГ</TableColumn>
                              <TableColumn>КОД</TableColumn>
                              <TableColumn>КАРГО ТӨЛБӨР</TableColumn>
                              <TableColumn></TableColumn>
                          </TableHeader>
                          <TableBody>
                              {
                                  datas.map((it, index) => {
                                      return(
                                          <TableRow key={index}>
                                              <TableCell>{it.product.name}</TableCell>
                                              <TableCell>{it.product.price}</TableCell>
                                              <TableCell>{it.phone_or_depo}</TableCell>
                                              <TableCell>{it.too}</TableCell>
                                              <TableCell className="text-xs">{it.code}</TableCell>
                                              <TableCell className="text-xs">{Number(it.pay * it.too)} <span>{it.leasing === LEASING_TYPES.Y && "Лизинг"}</span></TableCell>
                                              <TableCell>
                                                <div className='bg-gray-200 p-2 rounded-md hover:bg-gray-300 cursor-pointer w-10' onClick={()=> handleCheckClick(it)}>
                                                  <FaCheck size={20}/>
                                                </div>
                                              </TableCell>
                                          </TableRow>
                                      )
                                  })
                              }
                          </TableBody>
                      </Table>
                      {
                          load &&
                          <Spinner/>
                      }
                      <h1 className="m-2 uppercase font-bold text-end">Нийт каргоны төлбөр <span> {allpay} </span></h1>
                    </div>
                    <div className='w-60'>
                      <div>
                        <div className='rounded-md bg-gray-200 text-black mt-2 ml-1 p-4'> 
                            <div className='flex justify-between'>
                              <div className='w-full'>
                                <h1>Ачаа тоо</h1>
                                <h1 className='font-bold text-xl'>{checkedTracks.length}ш</h1>
                              </div>
                              <div className='w-full'>
                                <h1>Ачаа дүн</h1>
                                <h1 className='font-bold text-xl'>{calculateTotalPayment()}</h1>
                              </div>
                            </div>
                            {
                              checkedTracks.map((it, index) => {
                                return(
                                  <div key={index} className='flex justify-between items-center ring-2 ring-white bg-green-600 rounded-sm mt-2 p-2'>
                                    <div>
                                      <h1>{it.phone_no}</h1>
                                      <h1 className='text-gray-200 text-xs'>{it.product.name}</h1>
                                    </div>
                                    <h1 className='text-gray-100'>{it.payment}</h1>
                                    <MdDeleteOutline onClick={()=> handleDeleteClick(it)} className='cursor-pointer' color='red' size={20}/>
                                  </div>
                                )
                              })
                            }
                        </div>
                      </div>
                    </div>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Болих
                </Button>
                <ReqOkayModal callback={callback} user={data} data={checkedTracks}/>
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}